module.exports = __webpack_public_path__ + "static/media/img-ovato-mascot-who-hoo.18c4eeeb.pdf";